<template>
  <ul class="sidebar-menu">
    <li class="header">我的菜单</li>
 <!--    <li class="active treeview">
      <router-link to="/manage/dashboard"><i class="fa fa-desktop"></i>
        <span class="page">首页</span>
      </router-link>
    </li> -->
    <li class="treeview" v-for="(menu,index) in menus" >
      <router-link :to="{path: menu.url}" v-if="menu.url!='#'">
        <i class="fa fa-align-justify"></i>
        <span class="page">{{menu.name}}</span>
        <span class="pull-right-container">
        </span>
      </router-link>
      <a class="" v-else>
        <i class="fa fa-list-ul"></i><!-- fa-align-justify -->
        <span class="page">{{menu.name}}</span>
        <span class="pull-right-container">
        <i class="fa fa-angle-left pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu" v-if="menu.subMenu!=null">
        <li v-for="sub in menu.subMenu" >
          <router-link :to="{path: sub.url}">
            <i class="fa fa-list-alt"></i> <!-- fa-tasks-->
            <span class="page">{{sub.name}}</span>
          </router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'SidebarName',
    data() {
      return {
          menus:""
      }
    },
    methods: {

    },
    created: function () {
      var roles = window.localStorage.getItem("roles");
      if (roles == "ROLE_USER") {
        this.menus = require('../menus/user_menu.json');
      } else if (roles == "ROLE_ADMIN") {
        this.menus = require('../menus/admin_menu.json');
      }

    }
  }
</script>
<style>
  /* override default */
  .sidebar-menu > li > a {
    padding: 12px 15px 12px 15px;
  }
  .sidebar-menu li.active > a > .fa-angle-left, .sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }

  .sidebar-menu .treeview-menu>li>a{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?098fdb53